<script lang="ts" setup>
import { onMounted } from 'vue'

import { useUserStore } from '@/stores/user-store'

const userStore = useUserStore()

onMounted(() => {
  if (userStore.isAuthenticated) {
    userStore.identifyUser()
  }
})
</script>

<template>
  <RouterView />
</template>
